import {db} from "../firebase/firebase";
import {collection} from "firebase/firestore";
import {TABLE_USERS} from "tobl-data-schema/dist/schema/user";

export const COLLECTION_USERS = collection(db, TABLE_USERS);
